'use client'; // Error boundaries must be Client Components

import styles from './not-found.module.scss';

export default function Error() {
  return (
    <div className={styles.wrapper} style={{ height: '100vh' }}>
      <div className={styles.innerWrapper}>
        <div className={styles.details}>
          <h2 className={styles.title}>Oops!</h2>
          <p className={styles.description}>
            We can’t seem to find the page you’re looking for.
          </p>

          <p className={styles.errorCode}>
            Error code: <span>{'404'}</span>
          </p>

          <p className={styles.linksTitle}>
            Here are some helpful links instead:
          </p>
          <ul>
            <li>
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/faq.html">Frequently Asked Questions</a>
            </li>
            <li>
              <a href="/stores">Find a Store</a>
            </li>
            <li>
              <a href="/sale">Current Promotions</a>
            </li>
          </ul>

          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href="/" className={styles.actionButton}>
            Go Back
          </a>
        </div>

        <div className={styles.imageWrapper}></div>
      </div>
    </div>
  );
}
